import ExcelJS from 'exceljs';

export const downloadTransactionsTemplate = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Plantilla');

  worksheet.columns = [
    { header: 'Fecha', key: 'fecha', width: 15 },
    { header: 'Cédula', key: 'cedula', width: 15 },
    { header: 'Accionista', key: 'accionista', width: 30 },
    { header: 'Grupo Familiar', key: 'grupoFamiliar', width: 30 },
    { header: 'Tipo Movimiento', key: 'tipoMovimiento', width: 15 },
    { header: 'Detalle', key: 'detalle', width: 30 },
    { header: 'Valor', key: 'valor', width: 15 },
    { header: 'Clasificación', key: 'clasificacion', width: 30 },
  ];

  worksheet.addRow({
    fecha: '22/06/2026',
    cedula: '0999999999',
    accionista: 'Bruce Thomas Wayne Grayson',
    grupoFamiliar: 'Familia Wayne Grayson ',
    tipoMovimiento: '+',
    detalle: 'Donación dividendos 4',
    valor: '99,999.99',
    clasificacion: 'Donación Cxc Dividendos'
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = 'Plantilla_Transacciones.xlsx';
  anchor.click();

  window.URL.revokeObjectURL(url);
};
